'use strict';
const angular = require('angular');

export class newsWidgetComponent {

  constructor(NewsService) {
    'ngInject';

    this.NewsService = NewsService;
  }

  getPreviewText(text) {
    return text ? String(text).replace(/<[^>]+>/gm, ' ').substr(0, 150) + '...' : '';
  }

  convertShortcode(html) {
    return html.replace(/\[/g,"<").replace(/\]/g,">");
  }

  $onInit() {
    this.NewsService.getNewest({count: this.count || 3}, data => {
      this.data = data;
      this.data.forEach(news => {
        news.body = this.convertShortcode(news.body);
      });
    }, err => {
      console.log('could not retrieve newest news');
    });
  }
}

export default angular.module('conduuApp.newsWidget', [])
  .component('newsWidget', {
    template: require('./news-widget.component.html'),
    bindings: {
      count: '@'
    },
    controller: newsWidgetComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/sidebar/news-widget/news-widget.component.js